import { render } from "./MicrosoftConnectCard.vue?vue&type=template&id=d0ec3098&ts=true"
import script from "./MicrosoftConnectCard.vue?vue&type=script&lang=ts"
export * from "./MicrosoftConnectCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__